export default "__VITE_ASSET__C1etxbC7__"